import Vue from 'vue'

export const state = Vue.observable({
  period: '',
  documentType: '',
  sendNotification: true,
  sendPushNotification: true,
  companyEmail: '',
  file: '',
  idCarga: '',
  uploadedFileData: {}
})

export const mutations = {
  setPeriod: period => state.period = period,
  setDocumentType: documentType => state.documentType = documentType,
  setSendNotification: sendNotification => state.sendNotification = sendNotification,
  setSendPushNotification: sendPushNotification => state.sendPushNotification = sendPushNotification,
  setCompanyEmail: companyEmail => state.companyEmail = companyEmail,
  setFile: file => state.file = file,
  setIdCarga: idCarga => state.idCarga = idCarga,
  setUploadedFileData: data => state.uploadedFileData = data,
  cleanState: () => {
    state.period = '',
    state.documentType = '',
    state.sendNotification = true,
    state.sendPushNotification = true,
    state.companyEmail = '',
    state.file = '',
    state.idCarga = '',
    state.uploadedFileData = {}
  }
}